module.exports = __webpack_public_path__ + "images/cos-logo-mobile-ab04b1212c62ee526e4fdd5e06c898e4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/cos-logo-mobile.svg
// module id = 193
// module chunks = 0